import React from 'react';

const Section = ({ title, background = 'white', children, titleClassName = '', containerClassName = '' }) => {
  const bgClass = background === 'gray' ? 'bg-gray-50' : 'bg-white';

  return (
    <section className={`${bgClass} py-6`}>
      <div className={`mx-auto w-full max-w-[1400px] px-3 md:px-6 2xl:px-0 ${containerClassName}`.trim()}>
        {title && (
          <h2 className={`text-xl font-semibold uppercase tracking-wide text-gray-800 mb-6 ${titleClassName}`.trim()}>
            {title}
          </h2>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;
